// Cortex Audit — the PLATFORM's own compliance program, distinct from any
// project's audit page: the repo-level cortex program (audit runs over the
// application/engine codebase, the Mindshine control register, the compiled
// evidence records) plus the infrastructure layer (Prowler scans), which is
// cross-project by nature and therefore lives HERE and not on project pages.
//
// Same surface as the project Audit page (one component, different scope);
// runs and fixes happen through the auditor engine / dev workflow, so the
// in-app "Run audit" and "Fix with assistant" actions are disabled.
import React from "react";
import Audit from "./Audit";

export default function CortexAudit() {
  return (
    <Audit
      program="cortex"
      title="Cortex Audit"
      subtitle={<>standards compliance for the <b>cortex platform</b> — application, engine &amp; infrastructure (cross-project)</>}
      showPlatform
      allowRun={false}
      allowFix={false}
    />
  );
}
